import { UPDATE_ALERT } from '../actions/alert-actions';

export default function alertReducer(state = '', { type, payload }) {
    console.log(type, payload);
    switch (type) {
        case UPDATE_ALERT :
            console.log(UPDATE_ALERT)
            return payload.alert;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/alert-reducer.js